import { useState } from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { MiniLoader } from "../MiniLoader";
import { useEffect } from "react";

export const SelectRuc = (props) => {
  const { t } = useTranslation();
  const [rucList, setRucList] = useState(props.items || []);
  const [filtrado, setFiltrado] = useState(props.actual || []);
  const [loadingRucs, setLoadingRucs] = useState(props.loadingRucs);

  const handleSelect = (e) => {
    let filtroRucs = [];
    let rucs = document.getElementById("filter-matriculas").children;
    for (let i = 0; i < rucs.length; i++) {
      if (rucs[i].firstChild.firstChild.checked) {
        filtroRucs.push(rucs[i].firstChild.firstChild.value);
      }
    }
    props.onChange(filtroRucs);

    // Cerrar el dropdown al guardar los filtros
    document.getElementById("dropdown-autoclose-inside-matriculas").click();
  };

  useEffect(() => {
    setLoadingRucs(props.loadingRucs);
  }, [props.loadingRucs]);

  useEffect(() => {
    setRucList(props.items);
    setFiltrado(props.actual);
  }, [props.items, props.actual]);

  return (
    <>
      <Dropdown
        autoClose="outside"
        className="filter-secondary filter-matricula"
      >
        {loadingRucs && <MiniLoader />}
        {!loadingRucs &&
          rucList.length > 0 &&
          rucList[0] !== null &&
          rucList[0] !== undefined && (
            <Dropdown.Toggle
              id="dropdown-autoclose-inside-matriculas"
              className="btn-filter-secondary"
              variant={"filter-secondary"}
            >
              {t("repostajes.filtros.matriculas")}
            </Dropdown.Toggle>
          )}
        {!loadingRucs && (
          <Dropdown.Menu>
            <span id="filter-matriculas" className="filter-dropdown">
              {rucList.map((ruc) => (
                <Form.Group
                  className="dropdown-item mb-0"
                  controlId={"checkbox-filter-matricula-" + ruc}
                  key={"checkbox-filter-matricula-" + ruc}
                >
                  <Form.Check
                    type="checkbox"
                    label={ruc}
                    value={ruc}
                    defaultChecked={filtrado.includes(ruc)}
                  />
                </Form.Group>
              ))}
            </span>

            <Dropdown.Item className="save-filters">
              <Button variant="secondary" onClick={handleSelect}>
                {t("repostajes.filtros.btn-guardar")}
              </Button>
            </Dropdown.Item>
          </Dropdown.Menu>
        )}
      </Dropdown>
    </>
  );
};
